const supportedBrand = [31, 61];
const chaneelArray: string[] = ["channel901", "channel902", "channel51", "channel52", "channel53"];

export function addressablePxlInit(brandId: number): void {
    if (!supportedBrand.includes(brandId)) {
        return;
    }

    const _id: any = {
        31: '936596dc716e4e48b6ed53f3d30e2aa0',
        61: '936596dc716e4e48b6ed53f3d30e2aa0'
    }

    try {
        // Removed the '!' here
        (function (w: Window, d: Document): void {
            w.__adrsbl = {
                queue: [] as any[],
                run: function (...args: any[]): void {
                    this.queue.push(args);
                }
            };
            var id = _id[brandId];
            var s: HTMLScriptElement = d.createElement('script');
            s.async = true;
            s.src = `https://tag.adrsbl.io/p.js?tid=${id}`;
            var b: HTMLCollectionOf<HTMLScriptElement> = d.getElementsByTagName('script');
            // Using optional chaining (?. ) is a good practice here
            b[0].parentNode?.insertBefore(s, b[0]);
        })(window, document); // The IIFE is still invoked immediately
    } catch (error) {
        console.log('Issue in addressablePxl Init', error)
    }
}

export function addressablePxlPageView(brandId: number, channel: string = '') {
    try {
        if (supportedBrand.includes(brandId)) {

            if (typeof window.__adrsbl === 'undefined') {
                addressablePxlInit(brandId);
                const t = setTimeout(() => {
                    const conversion = channel && chaneelArray.includes(channel) ? true : false;
                    window.__adrsbl.run('page_View', conversion);
                }, 1000)
            }
            else {
                const conversion = channel && chaneelArray.includes(channel) ? true : false;
                window.__adrsbl.run('page_View', conversion);
            }
        }


    } catch (error) {
        console.log('Issue in addressablePxl', error)
    }
}

export function addressablePxlReg(brandId: number, channel: string = '') {
    try {
       
        if (supportedBrand.includes(brandId)) {
             if (typeof window.__adrsbl === 'undefined') {
                addressablePxlInit(brandId);
             }
            if (channel && chaneelArray.includes(channel)) { window.__adrsbl.run('registration', true) }
        }
    }
    catch (error) {
        console.log('Issue in addressablePxl', error)
    }
}

export function addressablePxlDeposit(brandId: number, channel: string = '') {
    try {
        if (supportedBrand.includes(brandId)) {
            if (channel && chaneelArray.includes(channel)) {
                if (typeof window.__adrsbl === 'undefined') {
                    addressablePxlInit(brandId);
                    const t = setTimeout(() => {
                        window.__adrsbl.run('deposit_ftd', true)
                    }, 1000)
                }
                else {
                    window.__adrsbl.run('deposit_ftd', true)
                }
            }
        }

    } catch (error) {
        console.log('Issue in addressablePxl', error)
    }
}

export function addressablePxlReDeposit(brandId: number, channel: string = '') {
    try {
        if (supportedBrand.includes(brandId)) {
            if (channel && chaneelArray.includes(channel)) {
                if (typeof window.__adrsbl === 'undefined') {
                    addressablePxlInit(brandId);
                    const t = setTimeout(() => {
                        window.__adrsbl.run('redeposit', true)
                    }, 1000)
                }
                else {
                    window.__adrsbl.run('redeposit', true)
                }
            }
        }

    } catch (error) {
        console.log('Issue in addressablePxl', error)
    }
}